export const errorMessage = {
    somethingWentWrong: 'Something went wrong, Please try again!',
    invalidPartner: 'Invalid Partner, Please Enter a Valid Partner URL!',
    invalidFacility: 'Unabled to Fetch Faclity , Please Try Again!',
    notFound: 'PAGE NOT FOUND',
    facilityChange: 'The rate for this permit might be revised from the next cycle in case of any change in Driver License number.',
    customer_banner_heading: 'SEAMLESS PERMIT PARKING',
    customer_banner_text: 'Parking offers a smooth and easy parking process, helping you book your monthly parking hassle free.',
    linkPhoneMessage: 'Please enter your phone number to link it with the card used',
    termsNConditions: 'I agree to the Terms of Service and Privacy Policy',
    invalidCredentials: 'Email ID already exists in our system, but the password provided is wrong. Please use the correct password or use a different email ID.',
    awayMessage: 'Data was updated while you were away. Please refresh to see the changes.',
    noDataAvailable: 'No data available',
    comingSoon: 'COMING SOON!',
    brand_settings_missing: 'Please update the Partner Brand Settings from admin',
    keyCardDisclaimerNote: 'Keycard availability and fees are permit-specific. Replacement may include additional charges.',
    invalidCardNumber: 'Invalid Card Number',
    couponRemoveMessage: 'By selecting previous date, the existing Coupon code will be removed, You will need to re-select/apply the coupon for new reservation dates.',
    reservationsNotAvailable: 'Please check back in a few hours as we reopen our reservations when spaces become available',
}